module.exports = __webpack_public_path__ + "static/media/instagram.4ec1ac9b.png";